
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fawnqmicztfgfojerfbn.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZhd25xbWljenRmZ2ZvamVyZmJuIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY5ODY5NzYzMCwiZXhwIjoyMDE0MjczNjMwfQ.mA2q5Ol1AGpiN0YZalg_1gf1xWU2fHA8Mjfy5SF-Z20';
const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase;

